import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { KycLandingPageStatus, ErrorPageContent } from "@ploy-ui/core";
import { useFetcher } from "@rest-hooks/core";
import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
import { useAppLoad } from "../../appLoadContext";
import { ErrorHandler } from "@ploy-lib/core";
import { LandingPageStatusesResource } from "@ploy-lib/rest-resources";
addRegisteredSectionLayout({
    name: "KycLandingPageStatusSection",
    displayName: "KycLandingPageStatusSection",
    settings: {}
});
const KycLandingPageStatusSectionInternal = memo((props) => {
    const { className, onClick, setSectionCompleted, formTemplateSectionId, hideSignerList, hideSignerEditing, showAlternativeMessage } = props;
    const { applicationId } = useAppLoad();
    const refetchLandingPageStatus = useFetcher(LandingPageStatusesResource.list());
    const refetchStatus = useCallback(() => {
        refetchLandingPageStatus({ applicationId });
    }, [refetchLandingPageStatus]);
    return (_jsx(KycLandingPageStatus, { applicationId: applicationId, className: className, externalPostback: refetchStatus }));
});
const KycLandingPageStatusSection = (props) => (_jsx(ErrorHandler, { fallback: e => (_jsx(ErrorPageContent, { className: props.className, onClick: props.onClick, header: _jsxs("span", { children: [KycLandingPageStatusSection.displayName, " failed to render."] }) })), children: _jsx(KycLandingPageStatusSectionInternal, { ...props }) }));
KycLandingPageStatusSection.displayName = "DployKycLandingPageStatusSection";
export { KycLandingPageStatusSection };
//# sourceMappingURL=KYCLaningPageStatusSection.js.map